export enum InformationMessageDestinationType {
    DIFFUSION_LIST,
    DYNAMIC,
    ROLE,
    USER,
    NONE
}
